
import paths from '../paths';
import { FeedClient } from './axiosFeedClient';
import { Icontext } from './interface';

export const getThredsApi = async (id: string): Promise<Icontext> => {
  try {
    const response = await FeedClient.get<Icontext>(paths.getThreds(id));
    return response.data;
  } catch (e) {
    throw e;
  }
};
